var _document;
export const GROWTH_PAYMENTS_LIB = 'growth-payments-lib';
import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory(GROWTH_PAYMENTS_LIB, {
  library: GROWTH_PAYMENTS_LIB,
  dimensions: {
    is_acceptance_test: JSON.stringify(!!((_document = document) !== null && _document !== void 0 && (_document = _document.cookie) !== null && _document !== void 0 && _document.includes('hs_selenium')))
  }
});